export const COLORS = {
  white: "#FFFFFF",
  brandGrey: "#E3E3E3",
  darkGrey: "#404040",
  darkGrey2: "#333f34",
  grey: "#64748b",
  grey2: "#f1f5f9",
  lightGrey: "#c9c9c9",
  veryLightGrey: "#f1f1f1",
  evenLighterGrey: "#f7f7f7",
  black: "#1d1d1d",
  gradientBackground:
    "linear-gradient(180deg, rgba(234,255,188,1) 0%, rgba(243,243,243,1) 21%);",
  background: "#f3f3f3",
  lightNeon: "#ADFF00",
  veryLightNeon: "#efffce",
  mintGreen: "rgb(0 255 181)",
  iconHintGreen: "#3fcd04",
  darkNeon: "#96DB03",
  menuText: "rgba(82,74,62,.82)",
  lightOrange: "#ffeed0",
  orange: "#FFA500",
  red: "#FF0000",
  lightRed: "#ffcece",
  yellow: "#FFFF00",
  blue: "#0000FF",
  lightGreen: "#c7ffe4bd",
  green: "#00e816",
  darkMainAccent: "#003e85",
  mainAccent: "#1670E2",
  veryLightMainAccent: "#d4dfff",
  evenLighterMainAccent: "#eaf0ff",
};
